// projects/flappy-bird/frontend/src/constants.ts

// Screen dimensions (logical, portrait orientation)
export const SCREEN_WIDTH = 320;
export const SCREEN_HEIGHT = 480;

// Bird properties
export const BIRD_X_POSITION = SCREEN_WIDTH / 4;
export const BIRD_RADIUS = 15; // For simple circle bird initially
export const BIRD_FLAP_STRENGTH = -7; // Negative for upward velocity
export const BIRD_GRAVITY = 0.4;
export const BIRD_MAX_VELOCITY = 10;
export const BIRD_INITIAL_Y = SCREEN_HEIGHT / 2;

// Pipe properties
export const PIPE_WIDTH = 60;
export const PIPE_GAP_HEIGHT = 120; // Space for bird to pass
export const PIPE_SPAWN_INTERVAL = 2000; // Milliseconds
export const PIPE_SPEED = 2; // Pixels per frame

// Colors (Sleek, Apple-like - placeholder, will refine)
// Using hex numbers for PixiJS
export const COLOR_BACKGROUND = 0x87CEEB; // Light Sky Blue
export const COLOR_BIRD = 0xFFD700;       // Gold
export const COLOR_PIPE = 0x008000;       // Green
export const COLOR_TEXT = 0xFFFFFF;       // White
export const COLOR_TEXT_STROKE = 0x000000; // Black

// Font
export const FONT_FAMILY = 'Arial, Helvetica, sans-serif'; // Clean, sans-serif

// Game states (Fixed for erasableSyntaxOnly)
export const GameState = {
    StartScreen: 'StartScreen', // Note: GameComponent uses 'menu', 'playing', 'gameOver'
    Playing: 'Playing',
    GameOver: 'GameOver'
} as const;
// Optional: if you need the union type elsewhere for type checking function parameters etc.
export type GameStateValue = typeof GameState[keyof typeof GameState]; 

// API Base URL
// For Vercel deployment, VITE_API_BASE_URL will be set as an environment variable.
// For local development, it falls back to localhost:3001.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';

// Rewrite Count: 3